module.exports = __webpack_public_path__ + "img/рз_1.98961c66.png";